import withSuspense from "../../../../hocs/withSuspense";
import { ContactInfoError, ContactInfoSkeleton } from "../../components";
import DocumentDeliveryPage from "./DocumentDeliveryPage";

export const DocumentDeliveryPageWithSuspense = withSuspense(
  DocumentDeliveryPage,
  {
    FallbackComponent: ContactInfoError,
    loading: (
      <ContactInfoSkeleton rows={2} testId="document-delivery-skeleton" />
    ),
  }
);
